import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import api from "../api/api";
import { Button } from "antd";

const SincronizarEbooks = () => {
  const [sincronizando, setSincronizando] = useState(false);

  const sincronizarEbooks = async (forzar = false) => {
    try {
      setSincronizando(true);

      const response = await api.post(
        `/api/v1/sincronizarEbooks?forzar=${forzar}`,
      );

      const data = response.data;

      // ==========================================
      // RESPUESTA EXITOSA 200
      // ==========================================
      if (response.status === 200) {
        await Swal.fire({
          icon: "success",
          title: "¡Sincronización completada!",
          html: `
            <div style="text-align: left;">

              <div style="
                background: #f0fdf4;
                border: 1px solid #bbf7d0;
                border-radius: 10px;
                padding: 15px;
                margin-bottom: 15px;
              ">
                <strong style="color: #166534;">
                  ${data.mensaje || "Sincronización aplicada correctamente."}
                </strong>
              </div>

              <div style="
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 10px;
                margin-top: 15px;
              ">

                <div style="
                  background: #f8fafc;
                  padding: 12px;
                  border-radius: 8px;
                  text-align: center;
                ">
                  <div style="font-size: 22px; font-weight: bold;">
                    ${data.totalRecibidosDeKotobee ?? 0}
                  </div>
                  <div style="font-size: 12px; color: #64748b;">
                    Recibidos de Kotobee
                  </div>
                </div>

                <div style="
                  background: #f8fafc;
                  padding: 12px;
                  border-radius: 8px;
                  text-align: center;
                ">
                  <div style="font-size: 22px; font-weight: bold;">
                    ${data.insertados ?? 0}
                  </div>
                  <div style="font-size: 12px; color: #64748b;">
                    Insertados
                  </div>
                </div>

                <div style="
                  background: #f8fafc;
                  padding: 12px;
                  border-radius: 8px;
                  text-align: center;
                ">
                  <div style="font-size: 22px; font-weight: bold;">
                    ${data.actualizados ?? 0}
                  </div>
                  <div style="font-size: 12px; color: #64748b;">
                    Actualizados
                  </div>
                </div>

                <div style="
                  background: #f8fafc;
                  padding: 12px;
                  border-radius: 8px;
                  text-align: center;
                ">
                  <div style="font-size: 22px; font-weight: bold;">
                    ${data.eliminados ?? 0}
                  </div>
                  <div style="font-size: 12px; color: #64748b;">
                    Eliminados
                  </div>
                </div>

              </div>

              ${
                data.ignoradosPorEliminadoEnKotobee > 0
                  ? `
                    <div style="
                      margin-top: 15px;
                      padding: 12px;
                      background: #fff7ed;
                      border: 1px solid #fed7aa;
                      border-radius: 8px;
                    ">
                      <strong>Ignorados por eliminación en Kotobee:</strong>
                      ${data.ignoradosPorEliminadoEnKotobee}
                    </div>
                  `
                  : ""
              }

            </div>
          `,
          confirmButtonText: "Aceptar",
          confirmButtonColor: "#0085CA",
          width: "600px",
        });

        return;
      }
    } catch (error) {
      // ==========================================
      // RESPUESTA 409 - REQUIERE CONFIRMACIÓN
      // ==========================================

      if (error.response?.status === 409) {
        const data = error.response.data;

        if (data?.requiereConfirmacion === true) {
          const idsAEliminar = data.idsAEliminar || [];

          const resultado = await Swal.fire({
            icon: "warning",
            title: "⚠️ Se requiere confirmación",
            html: `
              <div style="text-align: left;">

                <div style="
                  background: #fff7ed;
                  border: 1px solid #fed7aa;
                  border-left: 5px solid #f97316;
                  padding: 15px;
                  border-radius: 8px;
                  margin-bottom: 20px;
                ">
                  <div style="
                    font-size: 15px;
                    font-weight: 600;
                    color: #9a3412;
                    line-height: 1.5;
                  ">
                    ${data.mensaje}
                  </div>
                </div>

                <div style="
                  display: grid;
                  grid-template-columns: 1fr 1fr;
                  gap: 10px;
                  margin-bottom: 18px;
                ">

                  <div style="
                    background: #f8fafc;
                    border-radius: 8px;
                    padding: 14px;
                    text-align: center;
                    border: 1px solid #e2e8f0;
                  ">
                    <div style="
                      font-size: 24px;
                      font-weight: bold;
                      color: #0f172a;
                    ">
                      ${data.totalRecibidosDeKotobee ?? 0}
                    </div>

                    <div style="
                      font-size: 12px;
                      color: #64748b;
                    ">
                      Normas recibidas
                    </div>
                  </div>

                  <div style="
                    background: #fef2f2;
                    border-radius: 8px;
                    padding: 14px;
                    text-align: center;
                    border: 1px solid #fecaca;
                  ">
                    <div style="
                      font-size: 24px;
                      font-weight: bold;
                      color: #dc2626;
                    ">
                      ${data.ignoradosPorEliminadoEnKotobee ?? 0}
                    </div>

                    <div style="
                      font-size: 12px;
                      color: #991b1b;
                    ">
                      Normas a eliminar
                    </div>
                  </div>

                </div>

                <div style="
                  background: #f8fafc;
                  border: 1px solid #e2e8f0;
                  border-radius: 8px;
                  padding: 12px;
                ">

                  <div style="
                    font-weight: 600;
                    margin-bottom: 8px;
                    color: #334155;
                  ">
                    IDs que serían eliminados:
                  </div>

                  <div style="
                    max-height: 100px;
                    overflow-y: auto;
                    font-family: monospace;
                    font-size: 13px;
                    color: #475569;
                  ">
                    ${
                      idsAEliminar.length > 0
                        ? idsAEliminar.join(", ")
                        : "No se encontraron IDs."
                    }
                  </div>

                </div>

                <div style="
                  margin-top: 18px;
                  padding: 12px;
                  background: #fef2f2;
                  border-radius: 8px;
                  color: #991b1b;
                  font-size: 13px;
                ">
                  <strong>Importante:</strong>
                  al confirmar, se ejecutará nuevamente la sincronización se permitirá la eliminación
                  indicada.
                </div>

              </div>
            `,
            showCancelButton: true,
            confirmButtonText: "✓ Confirmar y sincronizar",
            cancelButtonText: "Cancelar",
            confirmButtonColor: "#dc2626",
            cancelButtonColor: "#64748b",
            width: "650px",
            reverseButtons: true,
            focusCancel: true,
          });

          // ==========================================
          // USUARIO CONFIRMA
          // ==========================================

          if (resultado.isConfirmed) {
            // Mostrar cargando mientras se ejecuta forzar=true
            Swal.fire({
              title: "Aplicando sincronización...",
              html: `
                <div style="margin-top: 10px;">
                  Se está ejecutando la sincronización
                  <strong>forzada</strong>.
                </div>
              `,
              allowOutsideClick: false,
              allowEscapeKey: false,
              showConfirmButton: false,
              didOpen: () => {
                Swal.showLoading();
              },
            });

            // Ejecutar nuevamente con TRUE
            try {
              const responseForzada = await api.post(
                "/api/v1/sincronizarEbooks?forzar=true",
              );

              const resultadoFinal = responseForzada.data;

              // ==========================================
              // RESULTADO FINAL
              // ==========================================

              if (responseForzada.status === 200) {
                await Swal.fire({
                  icon: "success",
                  title: "¡Sincronización aplicada!",
                  html: `
                    <div style="text-align: left;">

                      <div style="
                        background: #f0fdf4;
                        border: 1px solid #bbf7d0;
                        border-left: 5px solid #16a34a;
                        padding: 15px;
                        border-radius: 8px;
                        margin-bottom: 18px;
                      ">
                        <strong style="color: #166534;">
                          ${resultadoFinal.mensaje}
                        </strong>
                      </div>

                      <div style="
                        display: grid;
                        grid-template-columns: 1fr 1fr;
                        gap: 10px;
                      ">

                        <div style="
                          padding: 12px;
                          background: #f8fafc;
                          border-radius: 8px;
                          text-align: center;
                        ">
                          <strong style="font-size: 22px;">
                            ${resultadoFinal.totalRecibidosDeKotobee ?? 0}
                          </strong>
                          <br/>
                          <small>Recibidos</small>
                        </div>

                        <div style="
                          padding: 12px;
                          background: #f8fafc;
                          border-radius: 8px;
                          text-align: center;
                        ">
                          <strong style="font-size: 22px;">
                            ${resultadoFinal.insertados ?? 0}
                          </strong>
                          <br/>
                          <small>Insertados</small>
                        </div>

                        <div style="
                          padding: 12px;
                          background: #f8fafc;
                          border-radius: 8px;
                          text-align: center;
                        ">
                          <strong style="font-size: 22px;">
                            ${resultadoFinal.actualizados ?? 0}
                          </strong>
                          <br/>
                          <small>Actualizados</small>
                        </div>

                        <div style="
                          padding: 12px;
                          background: #f8fafc;
                          border-radius: 8px;
                          text-align: center;
                        ">
                          <strong style="
                            font-size: 22px;
                            color: #dc2626;
                          ">
                            ${resultadoFinal.eliminados ?? 0}
                          </strong>
                          <br/>
                          <small>Eliminados</small>
                        </div>

                      </div>

                    </div>
                  `,
                  confirmButtonText: "Aceptar",
                  confirmButtonColor: "#0085CA",
                  width: "600px",
                });
              }
            } catch (errorForzado) {
              Swal.fire({
                icon: "error",
                title: "Error al aplicar la sincronización",
                text:
                  errorForzado.response?.data?.mensaje ||
                  "Ocurrió un error al ejecutar la sincronización forzada.",
                confirmButtonText: "Aceptar",
                confirmButtonColor: "#dc2626",
              });
            }
          }

          return;
        }
      }

      // ==========================================
      // OTROS ERRORES
      // ==========================================

      Swal.fire({
        icon: "error",
        title: "Error de sincronización",
        html: `
          <div>
            <p>
              No fue posible ejecutar la sincronización.
            </p>

            ${
              error.response?.data?.mensaje
                ? `
                  <div style="
                    margin-top: 10px;
                    padding: 12px;
                    background: #fef2f2;
                    border-radius: 8px;
                    color: #991b1b;
                  ">
                    ${error.response.data.mensaje}
                  </div>
                `
                : ""
            }
          </div>
        `,
        confirmButtonText: "Aceptar",
        confirmButtonColor: "#dc2626",
      });
    } finally {
      setSincronizando(false);
    }
  };

  return (
    <Button
      type="primary"
      style={{
        backgroundColor: "#06c9ff",
        borderColor: "#170969",
        color: "#fff",
      }}
      onClick={() => sincronizarEbooks(false)}
      disabled={sincronizando}
    >
      {sincronizando ? (
        <>
          <span
            className="spinner-border spinner-border-sm me-2"
            role="status"
          />
          Sincronizando...
        </>
      ) : (
        <>
          <i className="fas fa-sync-alt me-2"></i>
          Sincronizar eBooks
        </>
      )}
    </Button>
  );
};

export default SincronizarEbooks;
